"use client";
import React from "react";

import { stegaClean } from "@sanity/client/stega";

import useIsMobile from "../../hooks/useIsMobile";

import { FooterData } from "../../../sanity/lib/queries/getFooterData";
import { NotFoundData } from "../../../sanity/lib/queries/getNotFoundData";

import { VideoElement } from "../../components/Video";
import { ImageElement } from "../../components/Image";
import { LocalizedLink } from "../link/localizedLink";

export interface PropsNotFound {
    footerData: FooterData;
}

export const NotFoundPage = ({ notFoundText, notFoundAsset, copyright }: NotFoundData) => {
    const cleanedText = stegaClean(notFoundText || "Page not found");

    const { isMobile } = useIsMobile();

    const containerRef = React.useRef<HTMLDivElement>(null);

    return (
        <div className="overflow-hidden not-found" ref={containerRef}>
            {!isMobile && (
                <LocalizedLink
                    slug=""
                    className="flex-row items-center justify-center flex-grow min-h-screen overflow-hidden animate-marquee xl:mx-5 d-not-found whitespace-nowrap"
                    label={
                        <>
                            {cleanedText?.split("[]").map((part, index) => {
                                if (index === 1) {
                                    return (
                                        <React.Fragment key={index}>
                                            {notFoundAsset?.asset?.[0]._type === "image" ? (
                                                <ImageElement
                                                    src={notFoundAsset.asset[0]}
                                                    width={2560}
                                                    alt={notFoundAsset.alt || ""}
                                                    className="aspect-[397/281] w-[397px] min-w-[397px] h-auto mx-3"
                                                />
                                            ) : (
                                                <VideoElement
                                                    src={
                                                        notFoundAsset?.asset?.[0].assetUrl?.url ||
                                                        ""
                                                    }
                                                    className="aspect-[397/281] w-[397px] h-auto mx-4"
                                                />
                                            )}
                                            {part.trim()}
                                        </React.Fragment>
                                    );
                                } else {
                                    return <React.Fragment key={index}>{part}</React.Fragment>;
                                }
                            })}
                            {cleanedText?.split("[]").map((part, index) => {
                                if (index === 1) {
                                    return (
                                        <React.Fragment key={index}>
                                            {notFoundAsset?.asset?.[0]._type === "image" ? (
                                                <ImageElement
                                                    src={notFoundAsset.asset[0]}
                                                    width={2560}
                                                    alt={notFoundAsset.alt || ""}
                                                    className="aspect-[397/281] w-[397px] min-w-[397px] h-auto mx-3"
                                                />
                                            ) : (
                                                <VideoElement
                                                    src={
                                                        notFoundAsset?.asset?.[0].assetUrl?.url ||
                                                        ""
                                                    }
                                                    className="aspect-[397/281] w-[397px] h-auto"
                                                />
                                            )}
                                            {part.trim()}
                                        </React.Fragment>
                                    );
                                } else {
                                    return (
                                        <React.Fragment key={index}>{part.trim()}</React.Fragment>
                                    );
                                }
                            })}
                        </>
                    }
                />
            )}
            {isMobile && (
                <div className="mx-2.5">
                    <p className="mt-32 m-display-1 ">
                        {cleanedText?.split("[]").map((part, index) => {
                            if (index === 1) {
                                return (
                                    <React.Fragment key={index}>
                                        {notFoundAsset?.asset?.[0]._type === "image" ? (
                                            <ImageElement
                                                src={notFoundAsset.asset[0]}
                                                width={900}
                                                alt={notFoundAsset.alt || ""}
                                                className="w-full h-auto aspect-[355/470] my-10 max-h-dvh"
                                            />
                                        ) : (
                                            <VideoElement
                                                src={notFoundAsset?.asset?.[0].assetUrl?.url || ""}
                                                className="w-full h-auto aspect-[355/470]"
                                            />
                                        )}
                                        {part.trim()}
                                    </React.Fragment>
                                );
                            } else {
                                return <React.Fragment key={index}>{part}</React.Fragment>;
                            }
                        })}
                    </p>
                </div>
            )}
            <div className=" mx-2.5 md:mx-5 mb-24 md:mb-[1.375rem] d-body-m pt-24 md:pt-[2.125rem] md:absolute bottom-0 right-0">
                <p>
                    ©{copyright || "dotsandlines"} {new Date().getFullYear()}
                </p>
            </div>
        </div>
    );
};
